import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';
import ShowFiles from '../updateGrRecord/ShowFiles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  button: {
    backgroundColor: 'transparent',
    textAlign: 'end',
    paddingTop: '1rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const QualityAssuranceQaApproval = (props) => {
  const classes = useStyles();

  const {
    qualityAssuranceInfo,
    asnDetails,
    receivedQuantityInfo,
    POLineRecordDetails,
  } = props;

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            {/* Quality Assurance Information */}
            Material Inspection Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Analytical Report (AR) Number{' '}
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {/* {presentFormatedData(
              qualityAssuranceInfo?.cmoAnalyticalReportNumber,
              '-'
            )} */}
            {presentFormatedData(
              qualityAssuranceInfo?.analyticalReportNumber,
              '-'
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Unit of Measurement (UOM)
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              POLineRecordDetails?.unitOfMeasurementOrdered,
              '-'
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Quantity used for Sampling
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              qualityAssuranceInfo?.samplingQuantityQA,
              'NA'
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Inspection Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {qualityAssuranceInfo?.cmoQADate
              ? presentFormatedData(
                  new Date(qualityAssuranceInfo.cmoQADate)
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        {/* Row 2 */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Sampling Material Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              qualityAssuranceInfo?.samplingMaterialNumberQA,
              'NA'
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Material Passed Quantity
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(qualityAssuranceInfo?.passedQtyQA, 'NA')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Material Rejected Quantity
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              qualityAssuranceInfo?.rejectedQuantityQA,
              'NA'
            )}
          </Typography>
        </Grid>
        {qualityAssuranceInfo?.reasonForRejection && (
          <Grid item xs={12} sm={12} className={classes.grid}>
            <Typography variant='body2' className={classes.font}>
              Reason for Rejection
            </Typography>
            <Typography variant='body2' className={classes.fontPadding}>
              {presentFormatedData(
                qualityAssuranceInfo?.reasonForRejection,
                'NA'
              )}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} sm={12} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            CoA
          </Typography>
          <ShowFiles
            files={qualityAssuranceInfo.COAFiles}
            name='COAFiles'
            isUploadFile={false}
            // filesRequired={QAValidations.coaFile?.required}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default QualityAssuranceQaApproval;
